import { render, staticRenderFns } from "./ChaoweiPrescriptionPage.vue?vue&type=template&id=b9262154&scoped=true"
import script from "./ChaoweiPrescriptionPage.vue?vue&type=script&lang=js"
export * from "./ChaoweiPrescriptionPage.vue?vue&type=script&lang=js"
import style0 from "./ChaoweiPrescriptionPage.vue?vue&type=style&index=0&id=b9262154&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9262154",
  null
  
)

export default component.exports